import { render, staticRenderFns } from "./NotificationsSharedTalentVisitedListItem.vue?vue&type=template&id=620d8ab1&scoped=true&"
import script from "./NotificationsSharedTalentVisitedListItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationsSharedTalentVisitedListItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsSharedTalentVisitedListItem.vue?vue&type=style&index=0&id=620d8ab1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620d8ab1",
  null
  
)

/* custom blocks */
import block0 from "./NotificationsSharedTalentVisitedListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports